<template>
    <div style="display: inline-block;">
      <span @click="show()" :id="'callbackdialog'+order.id">
        <slot></slot>
      </span>
      <el-dialog v-if="dialogFormVisible" class="el-dialog-sm el-dialog-sm-h3" :close-on-click-modal="false"
        :modal="!mobiletype" :visible.sync="dialogFormVisible" width="90%" @close="close()">
        <div :class="{mobile_upload_order:mobiletype}">
          <h3 class="text-center">撤回上一步</h3>
          <ul class="error-messages" v-if="!isEmptyErrors">
            <li v-for="error in errors">{{error[0].message}}</li>
          </ul>          
          <ProductList ref="ProductList" @showChooseImage="showChooseImage" :groupOrderLine="groupOrderLine"
                  :order="order" :goods_info="goods_info" :numEditable="true" :operation="'取消'"
                  v-on:changeType="changeType" :need_input_price="order.type==2"></ProductList>
            <el-form>
              <el-row>
                <el-col :span="24">
                  <el-form-item>
                    <el-button :disabled="loading" :loading="loading" style="margin: 20px 0 20px;" class="block" :type="'primary'" @click="submit">确定</el-button>
                  </el-form-item>
                </el-col>
              </el-row>
            </el-form>
        </div>
      </el-dialog>
    </div>
  </template>
  
  <script>
    import api from '../../../../services/api.js'
    import { API_HOST } from '../../../../services/constant.js'
    import ProductList from './ProductList'
    let _ = require('lodash')
  
    export default {
      name: 'CancelProduct',
      props: ['order', 'isSingle','mobiletype'],
      components: {
        ProductList: ProductList
      },
      computed: {
      },
      data() {
        return {
          needCancelAll:false,
          goods_info: [],
          uploadType: '1',
          groupOrderLine: [],
          dialogFormVisible: false,
          loading: false,
          isEmptyErrors: true,
          errors: {},
          ids: [],
          status: '', // 订单状态
          data: [],
          cancelGoods:[],
        }
      },
      methods: {
        showChooseImage() {
          this.$emit('showChooseImage', 'cancelType2product')
        },
        changeType(data) {
          this.uploadType = data
          this.isEmptyErrors = true
          this.errors = {}
        },
        show() {
          this.goods_info = [
            { image: '', remark: '', id: new Date().getTime() }
          ]
          this.dialogFormVisible = true
          this.status = this.order.status
          this.groupOrderLine = []
          _.each(this.order.goods_list.filter(i=>i.package_id == this.$store.state.curPackageId), item => {
            item.checked = true
           this.groupOrderLine.push(item)
          })
        },
        close() {
          this.isEmptyErrors = true
          this.errors = {}
        },
        async submit() {
            
            let params = { type:1,order_id:this.order.id,good_list:[] }
            this.groupOrderLine.forEach((item)=>{
                if(item.checked)
                    params.good_list.push({id:item.id,number:item.selectNum})
            })
            if(params.good_list.length==0)
                return
            api.post(this, {
              path: 'order.php?api=change_status',
              data: params,
              loading: 'loading'})
            .then((res)=>{
            //cur_pack.loading = false
            if (res.body.status == 'ok') {
                this.dialogFormVisible = false
                Object.assign(this.order, res.body.result)
                _.each(this.order.goods_list, good => {
                  if (good.status == 3 || good.status == 7) {
                    good.package_id = good.cancel_time
                  }
                })
                if(this.order.goods_list && this.order.goods_list.length)
                    this.order.groupOrderLines = _.groupBy(this.order.goods_list, 'package_id')
            }
            else{
                if(res.body.result == 'already_updated'){
                this.$msgbox.alert('订单数据已更新，点击确定会自动更新数据', '数据更新', {
                    confirmButtonText: '确定',
                    callback: action => {
                    this.order.status = res.description.status;
                    }
                })
                }
                else{
                this.$msgbox.alert(res.body.result, '错误')
                }
            }
            })
        },
        
        }
    }
  </script>
  
  <!-- Add "scoped" attribute to limit CSS to this component only -->
  <style scoped lang="scss">
    .popover-price {
      padding: 13px 13px;
      li {
        clear: both;
        text-align: right;
        color: #333333;
        line-height: 24px;
  
        span {
          float: left;
          color: #999999;
        }
  
        del {
          color: #B0B4BF;
        }
      }
  
      .line {
        float: left;
        width: 100%;
        height: 1px;
        border: 1px dashed #ccc;
      }
    }
    .cancel-body {
      display: flex;
    }
  
    .dialog-form {
      padding-bottom: 40px;
    }
  
    .tip {
      font-size: 16px;
      color: rgba(136, 136, 136, 1);
      line-height: 24px;
      margin-bottom: 5px;
    }
  
    .add-tip {
      font-size: 14px;
      color: rgba(102, 102, 102, 1);
      line-height: 24px;
      margin-left: 5px;
    }
  
    .back {
      float: left;
      color: #C0C4CC;
      font-size: 26px;
      line-height: 30px;
      cursor: pointer;
    }
  
    .select-address {
      padding-bottom: 7px;
      border-bottom: 1px solid #CDCDCD;
      margin-bottom: 10px;
    }
  
    .mobile_upload_order {
      padding: 10px;
    }
  
    .error-messages {
      display: block;
      background-color: #fff1f1;
      padding: 10px;
      text-align: center;
      color: #ff4650;
      line-height: 17px;
      margin-bottom: 10px;
      border-radius: 5px;
  
      li {
        font-size: 12px;
      }
    }
  
    .fee_row {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin: 15px 0;
    }
  
    .fee_row label.canEdit {
      cursor: pointer;
    }
    .promo_code{
      border: 1px solid #D9D9D9;
      display: inline-block;
      padding: 0 10px;
      font-size: 13px;
    }
  </style>


// WEBPACK FOOTER //
// src/pages/orders/list/single/CallBackProductDialog.vue